import { useState, useEffect } from 'react';
import { storeService, type Goal } from '@/lib/services/store.service';

export function useGoal(storeId: string | undefined) {
  const [goal, setGoal] = useState<Goal | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) {
      setLoading(false);
      return;
    }

    const fetchGoal = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await storeService.getActiveGoal(storeId);
        setGoal(data);
      } catch (err) {
        console.error('Error fetching goal:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch goal');
        setGoal(null);
      } finally {
        setLoading(false);
      }
    };

    fetchGoal();
  }, [storeId]);

  return { goal, loading, error };
}
